import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Classes from './style.module.css'
import Radio from '@mui/material/Radio';
import { GoSearch } from "react-icons/go";
export default class Thousandtwo extends Component {
    constructor(props) {
        super(props)
        const getValues = (props) => {
            var values = this.props.filterData
            if(values.includes(',')){
                if (values.indexOf(',') > -1) {
                    var arr = values.split(',')
                    return arr
                }
            }else{
                var arr = []
                arr.push(values)
                return arr
            }
            
        }
        this.state = {
            defVal: this.props.defdata,
            value:getValues(),
            daysnumberdisabled:true,
            duewithindays:0,
            filteredValue: getValues(props.filterData), 
            searchQuery: "", 
        }
        this.handleSearch=this.handleSearch.bind(this)
    }
    
    componentDidMount(){
        console.log(this.props.filterData)
        this.setState({duewithindays:this.props.duewithindays})
            if(this.props.defdata == 'Due Within'){
                this.setState({daysnumberdisabled:false})
            }
    }

    duedateonchange(e){
        if(e.target.value != '' || e.target.value != undefined){
            if(e.target.value<366){
                this.setState({duewithindays:e.target.value});this.storeValue('Due Within',e.target.value)
            }else{Swal.fire('Set value less than 365 days')}
        }else{
            Swal.fire('Set a numeric value')
        }
    }
    componentDidUpdate(preProps){
        if(preProps.filterData != this.props.filterData){
            const getdefValues = (data) => {
                var values = data
                if(values.includes(',')){
                    if (values.indexOf(',') > -1) {
                        var arr = values.split(',')
                        return arr
                    }
                }else{
                    var arr = []
                    arr.push(values)
                    return arr
                }
                
            }

            if(this.props.defdata == 'Due Within'){
                console.log('Test')
                this.setState({daysnumberdisabled:false})
            }
            this.setState({value : getdefValues(this.props.filterData),defVal:this.props.defdata, filteredValue: getdefValues(this.props.filterData), duewithindays:this.props.duewithindays})
        }
    }
  
      handleSearch = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        const filteredValue = this.state.value.filter((val) =>
          val.toLowerCase().includes(searchQuery)
        );
        this.setState({ searchQuery, filteredValue });
      };
    
    storeValue(e,duewithindays){
        this.setState({defVal:e})
        this.props.onChange(e,duewithindays)
    }

    render() {

        const getID = (val) => {
            if (val.indexOf(' ') > -1) {
                return val.replace(' ','') + (new Date()).getTime()
            }else{
                return val + (new Date()).getTime()
            }
            
        }
        return (
            <div className='mt-3'>
            <div className='textsearch mb-3'>
                  <input
                    className="textinp2"
                    type="text"
                    placeholder="Search..."
                    value={this.state.searchQuery}
                    onChange={this.handleSearch}
                   
                    autoFocus={true}
                  />
                  <GoSearch
                    className="searchtextinp"
                    
                  />
                </div>
                <hr style={{ color: "grey" }} />
            <div className={Classes.overflow} style={{maxHeight:"370px",overflow:"auto"}}>
                {   
                  this.state.filteredValue.length > 0 ?  
                  this.state.filteredValue.map((val,index)=>{
                        var check = false
                        if(val == this.state.defVal){
                            check = true
                        }
                        return (
                            <>
                                {
                                    val != 'Due Within' ?
                                    <div key={index} style={{display:"flex",alignItems:"center",marginBottom:"5px"}} onClick = {()=>this.setState({daysnumberdisabled:true,duewithindays:0})}>

                                        <Radio
                                              checked={check} 
                                                id={getID(val)} 
                                                onChange={(e) => this.storeValue(e.target.value,null)}
                                                value={val}
                                                name="radio-buttons"
                                                inputProps={{ 'aria-label': 'A' }}
                                                sx={{
                                                    p: 0.5,
                                                    color: '#29b6f6', 
                                                    '&.Mui-checked': {
                                                      color: '#29b6f6',
                                                    },
                                                  }}
                                              />
                                        <label htmlFor={getID(val)} style={{paddingLeft:"10px",cursor:'pointer'}}>{val}</label> <br />
                                    </div>
                                :
                                <div key={index} style={{display:"flex",alignItems:"center",marginBottom:"5px"}} onClick = {()=>this.setState({daysnumberdisabled:false})}>

<Radio
                                              checked={check} 
                                                id={getID(val)} 
                                                onChange={(e) => this.storeValue(e.target.value,null)}
                                                value={val}
                                                name="radio-buttons"
                                                inputProps={{ 'aria-label': 'A' }}
                                                sx={{
                                                    p: 0.5,
                                                    color: '#29b6f6', 
                                                    '&.Mui-checked': {
                                                      color: '#29b6f6',
                                                    },
                                                  }}
                                              />
                                    <label htmlFor={getID(val)} style={{paddingLeft:"10px",cursor:'pointer'}}>{val}</label> <br />
                                    <input type="number" id={'DueWithinDays'} value={this.state.duewithindays} min={0} max={365} onChange={(e) => this.duedateonchange(e)} name={'DueDateFilter'} defaultChecked={false} style={{ width: "38px", height: "20px" }} disabled={this.state.daysnumberdisabled}/>
                                    <label htmlFor={'DueWithin'} style={{ paddingLeft: "10px", cursor: "pointer" }}> Days</label>
                                </div>
                                }
                            </>
                        )
                    }):  <p style={{ textAlign: "center", color: "red" }}>No results found</p>
                    
                }
            </div>
            </div>        
        )
    }
}

